export function sendGoToListingEvent(listingId) {
    if (gAListings !== undefined) {
        let listingData = gAListings[listingId];

        let items = {
            event: 'select_item',
            ecommerce: {
                'items': [listingData]
            }
        };
        dataLayer.push(items);
    }
}